import * as React from 'react';

function SvgPendingApprove(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 18" {...props}>
      <g fill="#38B2A6">
        <path d="M13.526.02H1.372C.622.02.015.629.015 1.379v14.64c0 .75.608 1.357 1.357 1.357h8.164a.14.14 0 00.054-.01 2.174 2.174 0 01-.333-1.157v-.71c0-1.2.98-2.18 2.182-2.18h.21l.838-1.019a3.014 3.014 0 012.395-5.116V1.378c0-.75-.607-1.357-1.356-1.357zM3.31 3.55h3.46a.68.68 0 01.679.678.68.68 0 01-.679.678H3.31a.68.68 0 01-.679-.678.68.68 0 01.679-.679zm5.564 9.363H3.31a.68.68 0 01-.679-.678.68.68 0 01.679-.679h5.564a.678.678 0 110 1.357zM9.892 8.91H3.31a.68.68 0 01-.679-.679.68.68 0 01.679-.678h6.582a.678.678 0 110 1.357z" />
        <path d="M17.818 14.335h-.693l-1.866-2.263a1.991 1.991 0 10-2.52-1.252c.196.59.661 1.055 1.255 1.255l-1.863 2.267h-.692c-.645 0-1.164.522-1.164 1.164v.705c0 .645.523 1.164 1.164 1.164h6.379c.64 0 1.163-.523 1.163-1.164v-.709c0-.645-.522-1.164-1.163-1.167z" />
      </g>
    </svg>
  );
}

export default SvgPendingApprove;
